import { DEFAULT_COUNTRY_CODE } from './constants';

// TODO: Rename it and move it to /utils/constants.js.
const unexpectedErrorMessage = () => {
  const donorContactEmail =
    DEFAULT_COUNTRY_CODE === 'GB' ? 'enquiries.info@concern.net' : 'info@concern.net';
  const donorContactPhone = DEFAULT_COUNTRY_CODE === 'GB' ? '0800 032 4001' : '+353 1 417 7777';
  const donorContactPhoneSpaceless = donorContactPhone.replace(/\s/g, '');
  return `For help, please contact <a href="mailto:${donorContactEmail}">${donorContactEmail}</a> or <a href="tel:${donorContactPhoneSpaceless}">${donorContactPhone}</a>.`;
};

export default unexpectedErrorMessage;
